import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import PropTypes from 'prop-types';

class TableLoader extends React.Component {
    render() {
        return (
            <TableRow style={{ height: 0 }}>
                <TableCell colSpan={this.props.colSpan} style={{ borderBottom: 'none', padding: 0 }}>
                    <LinearProgress color="primary" />
                </TableCell>
            </TableRow>
        );
    }
}

TableLoader.propTypes = {
    colSpan: PropTypes.number.isRequired,
};

export default TableLoader;



// WEBPACK FOOTER //
// ./src/components/table/TableLoader.js